import React, { Component } from "react";
import CartItem from "./CartItem";
import { connect } from "react-redux";
import Alert from "@material-ui/lab/Alert";
import { withRouter } from "react-router";
import ShareCartDrawer from "./ShareCartDrawer";
import { isThisSecond } from "date-fns";
import {
  getDiscountedPrice,
  getProductDiscountAmount,
} from "../../../Helpers/promotions";
import { getProduct } from "../../../store/reducers/store";

class Cart extends Component {
  state = {
    shareCartDrawerOpen: false,
  };
  checkDietryRestriction = (item) => {
    const { cart_items, store, promo_items, settings } = this.props;
    let res = {};
    let isDairyFree = true;
    let isSugarFree = true;
    let isGlutenFree = true;
    let isNutFree = true;
    let isOrganic = true;
    let isVegan = true;
    let isVegetarian = true;
    let containsGluten = true;
    let containsNutsSesame = true;
    let containsDairy = true;
    let containsEgg = true;
    let containsSeafoodShellfish = true;
    let containsChilli = true;

    let current_product = getProduct(
      store.categories,
      item.id,
      item.category_id,
      item.parent
    );

    if (current_product) {
      if (!current_product.dietary_restrictions?.includes("Dairy free"))
        isDairyFree = false;
      if (!current_product.dietary_restrictions?.includes("Gluten free"))
        isGlutenFree = false;
      if (!current_product.dietary_restrictions?.includes("Sugar free"))
        isSugarFree = false;
      if (!current_product.dietary_restrictions?.includes("Nut free"))
        isNutFree = false;
      if (!current_product.dietary_restrictions?.includes("Vegan"))
        isVegan = false;
      if (!current_product.dietary_restrictions?.includes("Vegetarian"))
        isVegetarian = false;
      if (!current_product.dietary_restrictions?.includes("Organic"))
        isOrganic = false;
      if (!current_product.dietary_restrictions?.includes("Gluten"))
        containsGluten = false;
      if (!current_product.dietary_restrictions?.includes("Nuts/Sesame"))
        containsNutsSesame = false;
      if (!current_product.dietary_restrictions?.includes("Dairy"))
        containsDairy = false;
      if (!current_product.dietary_restrictions?.includes("Egg"))
        containsEgg = false;
      if (!current_product.dietary_restrictions?.includes("Seafood/Shellfish"))
        containsSeafoodShellfish = false;
      if (!current_product.dietary_restrictions?.includes("Chilli"))
        containsChilli = false;

      let options = item.options;
      let currentProductOptions = current_product.options;
      let selected_option = {};

      if (options) {
        for (let [key, value] of Object.entries(options)) {
          let existOption = currentProductOptions.find(
            (element) => element.id == key
          );
          selected_option = value.selectedOptions;
          if (existOption) {
            for (let [selected_key, selected_value] of Object.entries(
              selected_option
            )) {
              let existChoice = existOption.choices.find(
                (element) => element.id == selected_key
              );

              if (existChoice.dietary_restrictions) {
                if (!existChoice.dietary_restrictions?.includes("Dairy free"))
                  isDairyFree = false;
                if (!existChoice.dietary_restrictions?.includes("Gluten free"))
                  isGlutenFree = false;
                if (!existChoice.dietary_restrictions?.includes("Sugar free"))
                  isSugarFree = false;
                if (!existChoice.dietary_restrictions?.includes("Nut free"))
                  isNutFree = false;
                if (!existChoice.dietary_restrictions?.includes("Vegan"))
                  isVegan = false;
                if (!existChoice.dietary_restrictions?.includes("Vegetarian"))
                  isVegetarian = false;
                if (!existChoice.dietary_restrictions?.includes("Organic"))
                  isOrganic = false;
                if (!existChoice.dietary_restrictions?.includes("Gluten"))
                  containsGluten = false;
                if (!existChoice.dietary_restrictions?.includes("Nuts/Sesame"))
                  containsNutsSesame = false;
                if (!existChoice.dietary_restrictions?.includes("Dairy"))
                  containsDairy = false;
                if (!existChoice.dietary_restrictions?.includes("Egg"))
                  containsEgg = false;
                if (
                  !existChoice.dietary_restrictions?.includes(
                    "Seafood/Shellfish"
                  )
                )
                  containsSeafoodShellfish = false;
                if (!existChoice.dietary_restrictions?.includes("Chilli"))
                  containsChilli = false;
              }
            }
          }
        }
      }
    }

    res = {
      isDiaryFree: isDairyFree,
      isSugarFree: isSugarFree,
      isGlutenFree: isGlutenFree,
      isNutFree: isNutFree,
      isOrganic: isOrganic,
      isVegan: isVegan,
      isVegetarian: isVegetarian,
      containsGluten: containsGluten,
      containsNutsSesame: containsNutsSesame,
      containsDairy: containsDairy,
      containsEgg: containsEgg,
      containsSeafoodShellfish: containsSeafoodShellfish,
      containsChilli: containsChilli,
    };
    return res;
  };
  render() {
    const { language, store, showCheckCart, themeColor, settings } = this.props;
    const cartItems = this.props.cart.map((item, indx) => {
      let store_product = this.props.store.categories.find(
        (category) => category.id === item.category_id
      );

      if (item.parent) {
        store_product = store_product.products
          .find((parent) => parent.id === item.parent)
          .children.find((product) => product.id === item.id);
      } else {
        store_product = store_product.products.find(
          (product) => product.id === item.id
        );
      }

      const discountedPrice = getProductDiscountAmount(
        item,
        this.props.coupon,
        this.props.promotions,
        this.props.store.smart_promos
      );

      const priceAfterDiscount = getDiscountedPrice(
        item.total_price * item.quantity + item.quantityExcludedOptionsTotal,
        discountedPrice,
        null,
        item.options,
        item.quantity
      );
      return (
        <CartItem
          itemIndex={indx}
          product={item}
          originalProduct={store_product}
          name={
            language == "english" ? store_product.name : store_product.ar_name
          }
          key={"non_promo_cart_item" + item.id + " " + indx}
          quantity={item.quantity}
          subtotal={
            item.total_price * item.quantity + item.quantityExcludedOptionsTotal
          }
          totalPrice={item.total_price}
          priceAfterDiscount={priceAfterDiscount}
          dietaryRestrictions={this.checkDietryRestriction(item)}
          calculateNutritions={() => this.props.calculateNutritions()}
        />
      );
    });

    let Promo_Item_List = this.props.promo_items.map((item, indx) => {
      let store_product = this.props.store.categories.find(
        (category) => category.id === item.category_id
      );

      if (item.parent) {
        store_product = store_product.products
          .find((parent) => parent.id === item.parent)
          .children.find((product) => product.id === item.id);
      } else {
        store_product = store_product.products.find(
          (product) => product.id === item.id
        );
      }
      return (
        <CartItem
          itemIndex={indx}
          product={item}
          originalProduct={store_product}
          key={"promo_cart_item" + item.id + " " + item.promo + " " + indx}
          currency={
            language == "english"
              ? store.settings.currency_english
              : store.settings.currency_local
          }
          name={
            language == "english" ? store_product.name : store_product.ar_name
          }
          quantity={item.quantity}
          subtotal={
            item.total_price * item.quantity + item.quantityExcludedOptionsTotal
          }
          totalPrice={item.total_price}
          priceAfterDiscount={0}
          dietaryRestrictions={this.checkDietryRestriction(item)}
          calculateNutritions={() => this.props.calculateNutritions()}
        />
      );
    });

    return (
      <>
        {showCheckCart && (
          <Alert
            severity="warning"
            style={{
              position: "fixed",
              top: 54,
              width: "100%",
              direction: language == "english" ? "ltr" : "rtl",
              right: language == "arabic" && 0,
            }}
          >
            {language == "english"
              ? "Some products were removed, please review your cart"
              : "تمت إزالة بعض المنجات, الرجاء التأكد من السلة"}
          </Alert>
        )}
        <ShareCartDrawer
          open={this.state.shareCartDrawerOpen}
          close={() => this.setState({ shareCartDrawerOpen: false })}
        />
        <div style={{ marginTop: 30 }}>
          <p
            className="box-title"
            style={{ textAlign: language === "arabic" ? "right" : "left" }}
          >
            {language == "english" ? "Items " : "المشتريات "}-{" "}
            <span
              style={{
                color: themeColor,

                cursor: "pointer",
              }}
              onClick={() => this.props.history.push("/cart")}
            >
              {language === "arabic" ? "تعديل" : "edit"}
            </span>
            {settings.enable_sharing_carts_staff &&
              settings.enable_sharing_carts &&
              !!this.props.abandonedCartID && (
                <span
                  style={{
                    fontWeight: "bold",
                    color: themeColor,
                    float: language === "arabic" ? "left" : "right",
                    cursor: "pointer",
                  }}
                  onClick={() => this.setState({ shareCartDrawerOpen: true })}
                >
                  {language === "arabic" ? "مشاركة" : "share"}
                </span>
              )}
          </p>
          <div
            className="border-top border-bottom mx-0 py-3 bold"
            style={{ backgroundColor: "white" }}
            dir={language == "english" ? "ltr" : "rtl"}
          >
            {cartItems}
            {Promo_Item_List}
          </div>
        </div>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    store: state.store.store,
    language: state.store.language,
    showCheckCart: state.deliveryTime.showCheckCart,
    themeColor: state.store.store.settings.dark || "#0099cc",
    abandonedCartID: state.abandonedCart.id,
    settings: state.store.store.settings,
    promotions: state.cart.discounts,
    coupon: state.cart.promos,
  };
};

export default withRouter(connect(mapStateToProps)(Cart));
